import Button from '../../../../components/Button';
import toast from 'react-hot-toast';
import { StyledWrapper } from './style';

interface ApproveToastProps {
  onConfirmApprove: () => void;
  isLoading?: boolean;
  isAIFM?: boolean;
  isMultiFunds?: boolean;
}

export function ApproveToast({
  onConfirmApprove,
  isLoading,
  isAIFM,
  isMultiFunds
}: ApproveToastProps) {
  return (
    <StyledWrapper id="approve-toast">
      <p className="title" id="approve-toast-title">
        Report Approval
      </p>
      <p className="text" id="approve-toast-text">
        {isMultiFunds
          ? 'Are you sure you want to approve all fund reports?'
          : 'Are you sure you want to approve this report?'}{' '}
      </p>
      <div className="footer" id="approve-toast-footer">
        <div id="approve-toast-footer-spacer" />
        <div className="buttons" id="approve-toast-buttons">
          <Button
            id="approve-toast-cancel-button"
            size="sm"
            onClick={() => toast.remove()}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            id="approve-toast-confirm-button"
            isLoading={isLoading}
            onClick={onConfirmApprove}
            size="sm"
          >
            Yes, Approve
          </Button>
        </div>
      </div>
    </StyledWrapper>
  );
}
